import 'css-chunksrc/client/scenes/assignToTask/tasksSelection/scrollPane/styles.scss';export default {
  "scrollPane": "_scrollPane_1kvkl_1"
};